import { Collapse } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { get } from "lodash";
import Risks from "./Risks";
import Opportunities from "./Opportunities";
import { setPanel } from "../../../../../redux/ducks/RiskAnalysis";

const RiskAnalysis = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const panel = useSelector((state) => get(state.RiskAnalysisDuck, "panel", null));
  const [state, setState] = useState({ activePanel: panel });

  useEffect(() => {
    dispatch(setPanel(state.activePanel));
  }, [state.activePanel]);

  const items = [
    {
      key: "risks",
      label: t("projectsManagement.riskAnalysis.risks"),
      className: "mb-1em",
      children: <Risks />,
    },
    {
      key: "opportunities",
      label: t("projectsManagement.riskAnalysis.opportunities"),
      className: "mb-1em",
      children: <Opportunities />,
    },
  ];

  return (
    <>
      <Collapse
        items={items}
        accordion
        activeKey={panel}
        onChange={(key) => setState((prevState) => ({ ...prevState, activePanel: key[0] || null }))}
      />
    </>
  );
};

export default RiskAnalysis;
